import React from "react";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import {ButtonHeader} from '../../component/Button/ButtonHeader'
import {PortalList} from "../../component/PortalList/PortalList";
import {TitlePage} from "../../component/Page/Title";

const CustomHeader = () => {
  return <TitlePage title="Atividade dos Portais">
    <ButtonHeader key={1} icon="cog fa-2x" style={{
      border: 'none',
      display: 'none',
      backgroundColor: '#E5E5E5',
      color: '#666666',
      outline: 'none',
      borderRadius: 4,
      padding: 5,
      height: 40,
      width: 40,
      marginRight: '2%'
    }}/>
    <ButtonHeader key={2} icon="bars fa-2x" style={{border: 'none', display: 'none', backgroundColor: 'transparent', color: '#666666', outline: 'none', marginRight: '2%'}}/>
  </TitlePage>
}
export const PortalPage = ({history}) => {

  const breadcrumbs = [<BreadcrumbItem key={1} title="Portais"/>]
  return (
      <Page
          title="Portais"
          breadcrumbs={breadcrumbs}
          headerCustom={<CustomHeader/>
          }>
        <PortalList history={history}/>
      </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/PortalPage/PortalPage.js